<template>
  <v-hover>
    <!-- $router.push({ name: 'slide.id', params: { id } }) :style="`border-bottom: 4px solid var(--${status}) !important;`" -->
    <v-card
      v-ripple
      slot-scope="{ hover }"
      :class="
        ` card elevation-${hover ? 3 : 0} slide-card ${minWidth ? 'min-width' : ''} ${
          clickable ? 'link' : ''
        } ${borderless ? 'borderless' : ''} ${selected ? 'selected' : ''}`
      "
      :tile="tile"
      @dblclick.stop="
        openAssetInLayer ? openLayer(item) : $router.push({ query: { ...$route.query, asset: id } })
      "
      @click.left.exact.stop="
        openAssetInLayer ? openLayer(item) : $router.push({ query: { ...$route.query, asset: id } })
      "
    >
      <image-helper :is-registered-for-deletion="willDelete" :src="preview">
        <template slot="image-overlay">
          <template v-if="deletable">
            <v-btn class="delete-icon" dark fab x-small icon @click.stop="deleteSlide()">
              <v-icon>{{ icons.close }}</v-icon>
            </v-btn>
          </template>
          <div class="group-indicators">
            <v-avatar v-show="hasReference" :size="25" class="avatar-group-indicator" dark dense>R</v-avatar>
            <v-avatar v-show="hasPopup" :size="25" class="avatar-group-indicator" dark dense>P</v-avatar>
            <v-avatar v-show="hasAnimation" :size="25" class="avatar-group-indicator" dark dense>A</v-avatar>
          </div>
        </template>
      </image-helper>
      <v-divider />
      <div class="meta pa-3">
        <div>
          <div class="header mb-1 d-flex align-center" :style="fontByLocalisation">{{ subtitle }}</div>
          <div class="header-content" :style="{ ...fontByLocalisation, ...headerContentStyle }">
            {{ title }}
          </div>
          <div v-show="!dense" class="subheader ma-0 layout align-center mt-2">
            <div class="layout align-center ma-0 wrap">
              <div>{{ updated }} | &nbsp;</div>
              <div :style="fontColorByStatus">
                {{ workflowStatus || status.toUpperCase().replace('_', ' ') }}
              </div>
            </div>
            <v-spacer />
            <!-- <div>
              <selection-button :sid="id" :selection="{ _id: id, externalId: subtitle, name: title, image: preview }"/>
            </div>-->
          </div>
        </div>
      </div>
      <!-- <v-list class="py-0" dense subheader two-line>
        <v-list-item dense>
          <v-list-item-content>
            <div class="text-truncate title-name">{{ title }}</div>
            <v-list-item-subtitle class="external-id copy" @click.stop="$clipboard(subtitle)" >{{ subtitle }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text v-if="updated">
              {{ updated }}
            </v-list-item-action-text>
            <slot name="actions"></slot>
          </v-list-item-action>
        </v-list-item>
      </v-list>-->
    </v-card>
  </v-hover>
</template>

<script>
import ImageHelper from '../img/ImageHelper';
import icons from '../../mixins/icons';
import gql from 'graphql-tag';
import SelectionButton from '../core/buttons/SelectionButton.vue';
import { getSlideChildrenStatus } from '../../services/graph/slide.graph';

export default {
  name: 'MainCard',
  components: { ImageHelper, selectionButton: SelectionButton },
  mixins: [icons],
  props: {
    preview: {
      type: String,
      required: true,
      default: null
    },
    id: {
      type: String,
      required: true
    },
    tile: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'backlog'
    },
    workflowStatus: {
      type: String
    },
    workflowStatusColor: {
      type: String
    },
    compareMode: Boolean,
    localizationMode: Boolean,
    elevation: {
      type: String,
      default: '0'
    },
    selectable: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    hasReference: {
      type: Boolean,
      default: false
    },
    // hasAnimation: {
    //   type: Boolean,
    //   default: false
    // },
    // hasPopup: {
    //   type: Boolean,
    //   default: false
    // },
    deletable: {
      type: Boolean,
      default: false
    },
    updated: {
      type: String
    },
    minWidth: {
      type: Boolean,
      default: true
    },
    borderless: {
      type: Boolean,
      default: false
    },
    willDelete: {
      type: Boolean,
      default: false
    },
    openAssetInLayer: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean
    }
  },
  data() {
    return {
      isVisible: false,
      isMounted: false,
      hasAnimation: false,
      hasPopup: false,
      sibling: null
    };
  },
  computed: {
    cardStyle() {
      return {
        maxWidth: this.dense ? '200px' : '250px'
      };
    },
    headerContentStyle() {
      return this.dense
        ? {
            '-webkit-line-clamp': '1',
            '-webkit-box-orient': 'vertical'
          }
        : {
            '-webkit-line-clamp': '2',
            '-webkit-box-orient': 'vertical',
            maxHeight: '48px',
            height: '48px'
          };
    },
    fontByLocalisation() {
      return {
        color: this.localizationMode ? 'var(--salmon)' : ''
      };
    },
    fontColorByStatus() {
      const color = this.workflowStatus ? this.workflowStatusColor : `var(--${this.status}) !important`;
      return {
        color
      };
    }
  },
  mounted() {
    this.isMounted = true;
    this.getGroupInfo();
  },
  apollo: {
    sibling: {
      query: gql`
        query($slide: ID, $country: String, $forWhat: String) {
          getSiblingForSlaveByLocale(slide: $slide, country: $country, forWhat: $forWhat) {
            id
            compare_mode
            checked_group
            checked_references
            checked_translation
          }
        }
      `,
      variables() {
        return {
          slide: this.id,
          country: this.$store.state.product.selected.country,
          forWhat: 'slave'
        };
      },
      skip() {
        return !this.isMounted || !this.isVisible;
      },
      update: data => data.getSiblingForSlaveByLocale
    }
  },
  methods: {
    async getGroupInfo() {
      const value = await getSlideChildrenStatus({ slideId: this.id || this.item._id });
      this.hasAnimation = value.animations;
      this.hasPopup = value.popups;
    },
    visibilityChanged(isVisible) {
      this.isVisible = isVisible;
    },
    openLayer(slide) {
      this.$store.commit('slides/setActive', slide);
      this.$router.push({ query: { asset: slide._id } });
    },
    deleteSlide() {
      this.$emit('delete', this.item);
    }
  }
};
</script>

<style scoped>
.card {
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none;
  border-radius: 4px;
}
.title-name {
  font-size: 0.8em !important;
  line-height: 1.1em;
}
.meta {
  margin: 0px !important;
}
.meta .header {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
}
.meta .header-content {
  overflow: hidden;
  display: -webkit-box;
}
.meta .subheader {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #787f8c;
}
.slide-card {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  /* border-radius: 0px !important; */
}

.min-width {
  /*min-width: 250px;*/
}

.copy {
}
.copy:hover {
  border: 1px solid var(--new-blue);
  cursor: copy;
}

.delete-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: var(--dark) !important;
}

.selected {
  border: 3px inset #00b0ff !important;
}

.link {
  cursor: pointer;
}

.group-indicators {
  position: absolute;
  right: 5px;
  bottom: 5px;
}

.avatar-group-indicator {
  color: white !important;
  background-color: var(--dark) !important;
  margin: 2px;
  font-size: 12px;
}
.localization {
  font-size: 13px;
  background-color: var(--salmon);
  color: white;
  width: 100%;
}
.borderless {
  border: 0px !important;
}
</style>
